import { useQuery } from '@tanstack/react-query';
import { useEnvironment } from '@/context/environment/hooks';
import { QueryKeys } from '@/utils/query-keys';
import { GetOrganizationSettingsDto, getOrganizationSettings } from '../api/organization';

export const useFetchOrganizationSettings = () => {
  const { currentEnvironment } = useEnvironment();

  // ReNovu: Enable organization settings for self-hosted deployments
  const query = useQuery<{ data: GetOrganizationSettingsDto }>({
    queryKey: [QueryKeys.organizationSettings, currentEnvironment?._id],
    queryFn: async () => await getOrganizationSettings({ environment: currentEnvironment! }),
    enabled: !!currentEnvironment?._id,
    refetchOnMount: false,
  });

  return query;
};
